import type { NavigateFunction } from 'react-router'

/**
 * Browser history entries created by React Router carry `{ usr, key, idx }`
 * in `history.state` (@remix-run/router). `idx > 0` means there is a prior
 * in-app entry to return to with `navigate(-1)`; otherwise we fall back
 * (e.g. first load on a deep link).
 */
export function navigateBackOrHome(
  navigate: NavigateFunction,
  fallback: string = '/'
): void {
  if (typeof window === 'undefined') {
    navigate(fallback)
    return
  }
  const st = window.history.state as { idx?: number } | null
  const idx = st && typeof st.idx === 'number' ? st.idx : undefined
  if (typeof idx === 'number' && idx > 0) {
    navigate(-1)
  } else {
    navigate(fallback)
  }
}
